import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import { Pagination } from '@/components/shared/Pagination';

const StatusBadge = ({ birth }) => {
  const isOverdue = birth.statut === 'prevue' && new Date(birth.date_prevue) < new Date();
  return (
    <span className={`px-2 py-1 lg:px-3 lg:py-1 rounded-full text-xs font-medium ${
      birth.statut === 'ne' ? 'bg-green-100 text-green-700' :
      isOverdue ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'
    }`}>
      {birth.statut === 'prevue' ? (isOverdue ? 'En retard' : 'Prévue') : 
       birth.statut === 'ne' ? 'Née' : birth.statut}
    </span>
  );
};

export const BirthTableView = ({ paginatedBirths, getSheepById, canWrite, canDelete, openEditDialog, handleDelete, currentPage, totalPages, onPageChange, startIndex, itemsPerPage, totalItems }) => (
  <Card className="border-0 shadow-md">
    <CardHeader><CardTitle className="text-xl">Tableau des naissances</CardTitle></CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b-2 border-gray-200 dark:border-gray-800">
              <th className="text-left py-3 px-2 lg:px-4 font-semibold text-gray-700 text-xs lg:text-sm">Mère</th>
              <th className="text-left py-3 px-2 lg:px-4 font-semibold text-gray-700 text-xs lg:text-sm">Date prévue</th>
              <th className="text-left py-3 px-2 lg:px-4 font-semibold text-gray-700 text-xs lg:text-sm hidden md:table-cell">Date réelle</th>
              <th className="text-center py-3 px-2 lg:px-4 font-semibold text-gray-700 text-xs lg:text-sm">Statut</th>
              <th className="text-right py-3 px-2 lg:px-4 font-semibold text-gray-700 text-xs lg:text-sm">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedBirths.length === 0 ? (
              <tr><td colSpan="5" className="text-center py-8 text-gray-500 dark:text-gray-400">Aucune naissance enregistrée</td></tr>
            ) : paginatedBirths.map((birth) => {
              const mere = getSheepById(birth.mere_id);
              return (
                <tr key={birth.id} className="border-b border-gray-100 hover:bg-gray-50 dark:hover:bg-gray-900">
                  <td className="py-3 px-2 lg:px-4 text-gray-900 text-xs lg:text-sm">
                    {mere ? `N\u00b0 ${mere.numero} ${mere.nom || ''}`.trim() : 'Mère supprimée'}
                  </td>
                  <td className="py-3 px-2 lg:px-4 text-gray-900 text-xs lg:text-sm">
                    {new Date(birth.date_prevue).toLocaleDateString('fr-FR')}
                  </td>
                  <td className="py-3 px-2 lg:px-4 text-gray-600 text-xs lg:text-sm hidden md:table-cell">
                    {birth.date_reelle ? new Date(birth.date_reelle).toLocaleDateString('fr-FR') : '-'}
                  </td>
                  <td className="py-3 px-2 lg:px-4 text-center"><StatusBadge birth={birth} /></td>
                  <td className="py-3 px-1 lg:px-4 text-right">
                    <div className="flex gap-1 justify-end">
                      {canWrite && <Button variant="ghost" size="sm" onClick={() => openEditDialog(birth)} className="text-blue-600 hover:bg-blue-50 p-1 lg:p-2" title="Modifier"><Edit className="w-3 h-3 lg:w-4 lg:h-4" /></Button>}
                      {canDelete && <Button variant="ghost" size="sm" onClick={() => handleDelete(birth.id)} className="text-red-600 hover:bg-red-50 p-1 lg:p-2" title="Supprimer"><Trash2 className="w-3 h-3 lg:w-4 lg:h-4" /></Button>}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} startIndex={startIndex} itemsPerPage={itemsPerPage} totalItems={totalItems} label="naissances" />
    </CardContent>
  </Card>
);
